module.exports = __webpack_public_path__ + "static/media/sent.0b8f68f3.svg";